import { OrderPaymentType } from "@sellar-io/api-v2/types";
import { CheckoutInvoiceMethod, CheckoutPaymentType } from "./types";

export const mapToLegacyPaymentType = ({
  paymentType,
  invoiceMethod,
}: {
  paymentType: CheckoutPaymentType;
  invoiceMethod: CheckoutInvoiceMethod;
}): OrderPaymentType => {
  switch (paymentType) {
    case "new-card-payment":
    case "existing-card-payment":
      return "checkout";
    case "credit-account":
    case "request-proforma-invoice":
    case "pay-on-delivery":
      return invoiceMethod === "stripe-invoice" ? "stripe" : "manual";
    case "sellar-credit":
      return "sellarCredit";
    case "new-ryft-card-payment":
      return "cardPayment";
    case "new-card-payment-with-deposit":
    case "existing-card-payment-with-deposit":
      return "cardPaymentWithDeposit";
    case "request-credit-terms":
    default:
      return "manual";
  }
};

export const mapPaymentLinkRequested = ({
  paymentType,
  paymentLinkRequested,
}: {
  paymentType: OrderPaymentType;
  paymentLinkRequested?: boolean;
}) => paymentType === "manual" && paymentLinkRequested === true;
